import {Component, Inject} from '@angular/core';
import {MODAL_DATA, NgbActiveModal} from '@agilent/ui-element';


@Component({
  template: `
    <ag-dialog header="Logs ">
      <ag-dialog-content>
        <ngx-json-viewer [json]="logs" [expanded]="false"></ngx-json-viewer>
      </ag-dialog-content>
      <ag-dialog-actions>
        <ag-button type="primary" (click)="close()" value="Close" id="close-btn"></ag-button>
      </ag-dialog-actions>
    </ag-dialog>
  `
})
export class ShadowDetailsComponent {

  logs: string;

  constructor(
    private activeModal: NgbActiveModal,
    @Inject(MODAL_DATA) private modalData: any
  ) {

    this.logs = modalData.data;
  }

  close() {
    this.activeModal.dismiss();

  }
}
